export default __webpack_public_path__ + "static/media/delivery-2.c5d4a971.png";